// Wraps a lazy `import()` so a stale-deploy chunk-load failure surfaces as a clear,
// actionable message instead of a cryptic console error and silent failure.
//
// Every lazy-loaded library chunk (jszip, sql.js, jspdf, marked — used by Anki
// import/export, backup export/restore, and Flash Notes PDF export) is fetched from the
// server only when the feature is actually used, not on initial page load. A tab left
// open across a deploy still has the OLD main bundle in memory, which remembers the OLD
// content-hashed chunk filenames — but Vercel only serves the latest deployment's files,
// so that fetch 404s. Because of the SPA catch-all rewrite, a missing file returns the
// app's own index.html instead of a real 404, which the browser then rejects with
// "Failed to load module script: ... MIME type text/html" — confusing on its own, and
// silent to the user unless the caller happens to have its own catch+message.
//
// @param {() => Promise<any>} importFn - a closure like () => import('jszip')
// @param {string} [featureName] - used in the friendly error message
export async function safeImport(importFn, featureName = 'This feature') {
    try {
        return await importFn();
    } catch (err) {
        const msg = String(err?.message || err || '');
        const isChunkLoadFailure = /dynamically imported module|module script|Importing a module script failed|Loading chunk|loading css chunk/i.test(msg);
        if (isChunkLoadFailure) {
            const friendly = new Error(`${featureName} needs a fresh copy of the app to work — please reload the page and try again.`);
            friendly.isChunkLoadFailure = true;
            throw friendly;
        }
        throw err;
    }
}
